import WithFlashingPrice from'./WithFlashingPrice';export default WithFlashingPrice;